<template>
  <div>
    <div :class="`nav-bottom`" v-if="auth && this.$device.mobile">
      <v-bottom-nav :active.sync="activeBtn" :value="showNav" color="#215688" :fixed="true">
        <!-- <v-btn flat color="white" router :to="'/dashboard/usdt-cfa'">
          <span class="white--text">Trades</span>
          <v-icon color="white">dashboard</v-icon>
        </v-btn> -->
        <v-btn flat color="white" router :to="'/exchange'">
          <span class="white--text">Swap Echange</span>
          <v-icon color="white">autorenew</v-icon>
        </v-btn>
        <v-btn flat color="white" router href="/dashboard/funds">
          <span class="white--text">Solde</span>
          <v-icon color="white">money</v-icon>
        </v-btn>

        <v-btn flat color="white" router :to="'/dashboard/account'">
          <span class="white--text">compte</span>
          <v-icon color="white">person</v-icon>
        </v-btn>
      </v-bottom-nav>
    </div>

   
  </div>
</template>

<script>
import { mapGetters} from "vuex";
export default {
    data() {
        return {
        activeBtn: 1,
        showNav: true,
        pwa:false,
        window:''
        }
    },
    computed: {
    ...mapGetters("authfb", ["user", "auth"])
  },
  mounted () {
    const standalone= ()=> (window.matchMedia('(display-mode: standalone)').matches);
    this.pwa=standalone()
    this.window=window.innerWidth
  },
   
};
</script>

<style lang="scss" scoped>
.nav-bottom {
  width: 100%;
  position: fixed;
  bottom: 0;
}
</style>